import { render, staticRenderFns } from "./AgendaEventTemplate.vue?vue&type=template&id=492ca392&"
import script from "./AgendaEventTemplate.vue?vue&type=script&lang=js&"
export * from "./AgendaEventTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports